import { render, staticRenderFns } from "./sectionFooter.vue?vue&type=template&id=0dd69881&scoped=true&"
var script = {}
import style0 from "./sectionFooter.vue?vue&type=style&index=0&id=0dd69881&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dd69881",
  null
  
)

export default component.exports